import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Calendar, ArrowRight, CircleCheck as CheckCircle2 } from 'lucide-react';
import { Button } from '../components/Button';
import { ProtectedLayout } from '../components/ProtectedLayout';

const CALL_BENEFITS = [
  'Review your alignment audit results with an expert',
  'Get personalized strategies for your growth systems',
  'Identify your highest-leverage next steps',
  'Build a clear action plan aligned with your values',
];

export function AlignmentCall() {
  const navigate = useNavigate();

  return (
    <ProtectedLayout>
      <div className="min-h-screen bg-gradient-to-br from-teal-50 to-blue-50 py-12 px-4">
        <div className="max-w-3xl mx-auto">

          <div className="text-center mb-8">
            <div className="inline-flex items-center justify-center w-20 h-20 bg-teal-600 rounded-full mb-4">
              <Calendar className="w-10 h-10 text-white" />
            </div>
            <h1 className="text-4xl font-bold text-gray-900 mb-4">
              Book a Systems Alignment Call
            </h1>
            <p className="text-xl text-gray-700">
              Get expert guidance to accelerate your alignment journey.
            </p>
          </div>

          <div className="bg-white rounded-lg shadow-lg p-8 mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">What to Expect</h2>
            <p className="text-gray-700 mb-6">
              In this free 30-minute call, you'll work one-on-one with an alignment coach to review your audit results
              and map out a clear, values-driven path forward.
            </p>
            <ul className="space-y-3">
              {CALL_BENEFITS.map((benefit) => (
                <li key={benefit} className="flex items-start gap-3">
                  <CheckCircle2 className="w-5 h-5 text-teal-600 flex-shrink-0 mt-0.5" />
                  <span className="text-gray-700">{benefit}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="bg-white rounded-lg shadow-lg p-8 mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-2 flex items-center gap-2">
              <Calendar className="w-6 h-6 text-teal-600" />
              Choose a Time
            </h2>
            <p className="text-gray-600 mb-6 text-sm">
              Select a date and time that works for you. The call is completely free and there's no obligation.
            </p>
            <div className="border rounded-lg overflow-hidden">
              <iframe
                src="https://calendar.google.com/calendar/appointments/schedules/AcZssZ0W9PY_gqVci3-i03S1rbhC3TfGTSCUI89GiSoiwsAsWlQE92gYvPYhXUXUiZvZqF9xRN77BRmL?gv=true"
                style={{ border: 0 }}
                width="100%"
                height="600"
                frameBorder="0"
                title="Book a Systems Alignment Call"
              />
            </div>
            <p className="text-sm text-gray-500 mt-4 text-center">
              Scheduling is completely optional. You can skip this and continue in the app.
            </p>
          </div>

          <div className="flex justify-center">
            <Button
              onClick={() => navigate('/dashgrowthloop')}
              className="px-8 py-4 text-lg"
            >
              Continue in App
              <ArrowRight className="w-5 h-5 ml-2" />
            </Button>
          </div>

        </div>
      </div>
    </ProtectedLayout>
  );
}
